export default function formatPhone(phone) {
  if (!phone) return;
  let ph = phone.toString();

  ph = ph.replace(/[/+()_-]*/g, '').replace(/\s/g, '');

  if (ph.length === 11) {
    const pattern = new RegExp(
      `(^\\d{${ph.length % 10}})(\\d{3})(\\d{3})(\\d{2})(\\d{2}$)`,
    );

    ph = ph.replace(pattern, '+$1 ($2) $3-$4-$5');

    return ph;
  }

  return phone;
}

/**
 * @description remove all "(", ")" and spaces from phone string
 *
 * @param {string} phone
 * @returns {number}
 *
 * @usage formatPhoneToNumber('+7 (123) 456-78-90') // -> +71234567890
 */
export function formatPhoneToNumber(phone) {
  return phone.replace(/[\(\)\s\-]/g, '');
}
